import { LogLevelDesc } from 'loglevel';

const appName = 'my-professional-team';

export const baseDomain = (): string => {
  return process.env.BASE_DOMAIN || 'immobilienscout24.de';
};

export const backendServer = (): string => {
  return process.env.BACKEND_SERVER || '';
};

export const logHttpSink = (): string | undefined => {
  return backendServer() ? `${backendServer()}/console/log` : undefined;
};

export const logLevel = (): LogLevelDesc => {
  return (process.env.LOG_LEVEL || 'info') as LogLevelDesc;
};

export const loginUrl = (): string => {
  return (process.env.SSO_URL || '') + '/sso/login?appName=' + appName + '&sso_return=' + window.location;
};

export const scoutManagerDashboardUrl = (): string => {
  return `https://${baseDomain()}/scoutmanager/dashboard`;
};

export const profileUrl = (): string => {
  return `https://${baseDomain()}/geschlossenerbereich/start.html`;
};

export const teamManagementUrl = (): string => {
  return `https://myteam.${baseDomain()}/`;
};

export const companyDataUrl = (): string => {
  return `https://${baseDomain()}/account/verwaltung/firmendaten.html`;
};

export const stage = (): string => {
  return process.env.STAGE == 'pro' ? 'pro' : 'box';
};
